import * as React from "react";
import { useParams } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { TextArea } from "@progress/kendo-react-inputs";
import { GetPermissions } from '../components/Options';
import { useNavigate } from "react-router-dom";
import { GetCloudLogin } from "../WeighBridge/Helpers";
import "./PrintTransactions.scss";

const PrintTransactions = () => {
    const { id } = useParams(); // offences/id url is used to edit existing offense, otherwise id is undefined
    const [ docket, setDocket ] = React.useState("");
    const [ printText, setPrintText ] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const navigate = useNavigate();
    const logo = React.useRef();
    if (permissions && !permissions.CanView) navigate("/");
    if (localStorage.getItem("userid") === null) navigate("/logout");

    React.useEffect(() => {
        GetPermissions(["ViewTransaction"], setPermissions);
        GetCloudLogin((cred) => {
            const baseUrl = (cred.token !== undefined && cred.token !== "" ? GetSession().CloudURL : configData.SERVER_URL);
            const timeOffset = new Date().getTimezoneOffset() / 60;
            var url = `${baseUrl}apiv7/private/getdockettext?transactionid=${id}&offset=${timeOffset}`;
            const init = {
              method: 'GET',
              accept: 'application/json',
                headers: { "Authorization": "Bearer " + (cred.token !== undefined && cred.token !== "" ? cred.token : GetToken()) }
            }
            fetch(url, init).then(response => response.text()).then(d => { 
                let dt = d.replace(/\[b\]/gi, "").replace(/\[\/b\]/gi, "");
                setDocket(dt);
                let x = String(d).replace(/\r/g, "").split('\n');
                let t = "";
                x.map(s => {
                    let line = s.replace(/\[b\]/gi, "<b>").replace(/\[\/b\]/gi, "</b>");
                    let sp = line.split(':');
                    if (sp.length > 1) {
                        t += `<tr><td>${sp[0]}</td><td>: ${sp[1]}</td></tr>`;
                    } else {
                        t += `<tr><td colspan="2">${s}</td></tr>`
                    }
                });
                let pv = "";
                if (logo.current !== undefined) pv += `<img src='${logo.current}' />`;
                pv += "<table style='font-size: 9pt'>" + t + "</table>";
                setPrintText(pv);
            });
        });
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };

        let sid = GetSession().SiteID;
        let url = `${configData.SERVER_URL}apiv7/sites/${sid}`;
        fetch(url, init).then(response => response.json()).then(d => {
            if (d !== null && d !== undefined) logo.current = d.fax;
        });

    }, []);

    const Print = () => {
        var newWin = window.open('', 'Print-Window');
        newWin.document.open();
        newWin.document.write('<html><head><title>Transaction ' + id + '</title><footer>Transaction ' + id + '</footer></head><body style="font-family:Arial,Helvetica;" onload="window.print()"><div>' + printText + '</div></body></html>');
        newWin.document.close();
        setTimeout(function () { newWin.close(); }, 10);
    }

    const Back = () => {
        navigate("/transactions");
    };

    return (
        <div className="wm-print-transaction">
            <div className="wm-print-transaction__panel">
                <div className="wm-print-transaction__header">
                    <div>
                        <h1>Print Transaction</h1>
                        <p>Review docket {id} before printing.</p>
                    </div>
                    <div className="wm-print-transaction__actions">
                        <Button className="wm-print-transaction__button wm-print-transaction__button--secondary" icon="arrow-left" onClick={Back}>Back</Button>
                        <Button className="wm-print-transaction__button wm-print-transaction__button--primary" icon="print" onClick={Print}>Print</Button>
                    </div>
                </div>

                <div className="wm-print-transaction__body">
                    <TextArea className="wm-print-transaction__preview" rows={30} value={docket} />
                </div>
            </div>
        </div>
    );
}

export default PrintTransactions;
